import { render, staticRenderFns } from "./Fundingdetails.vue?vue&type=template&id=aa0d91ec&scoped=true&"
import script from "./Fundingdetails.vue?vue&type=script&lang=js&"
export * from "./Fundingdetails.vue?vue&type=script&lang=js&"
import style0 from "./Fundingdetails.vue?vue&type=style&index=0&id=aa0d91ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa0d91ec",
  null
  
)

export default component.exports